import React from "react";
import { Information } from "src/components/login/Information";
import VerifyEmail from "../@jumbo/components/Common/authComponents/VerifyEmail";

const VerifyEmailPage = () => (
	<>
		<Information />
		<VerifyEmail variant="standard" wrapperVariant="bgColor" />
	</>
		);

export { VerifyEmailPage };
